'use strict';

import config from '../js/config';
import { runRequest } from '../utilities/makeRequest';
import * as featureFlags from '../utilities/featureFlags';

const csrfTokenStorageKey = 'csrfToken';

export async function getToken() {
  let key = null;
  if (!featureFlags.csrfEnabled.isEnabled()) {
    await new Promise((resolve) => {
      resolve(true);
    }).then(() => { key = 'csrf_not_enabled' });
  }
  else {
    let csrfWithTime = sessionStorage.getItem(csrfTokenStorageKey);
    let time = null;
    if (csrfWithTime !== null) {
      let arr = csrfWithTime.split(',');
      if (arr.length > 1) {
        time = arr[1];
        if (time > (new Date()).getTime()) {
          key = arr[0];
        } else {
          sessionStorage.removeItem(csrfTokenStorageKey);
        }
      }
    }

    if (key === null) {
      key = await getCsrfTokenNew();
    }
  }

  return await key;
}

async function getCsrfTokenNew() {
  try {
    const response = await runRequest({
      url: `${config.urls.csrfTokenUrl}`,
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      }
    });

    const csrf = response.response;
    const time = (new Date()).getTime() + csrf.ttl_in_min * 60000;
    const csrfToken = csrf.token;

    sessionStorage.setItem(csrfTokenStorageKey, csrfToken + ',' + time);
    return csrfToken;
  }
  catch (error) {
    console.error('Failed to fetch CSRF token', error);
    throw error;
  }
}



// WEBPACK FOOTER //
// ./assets/services/CsrfService.js